module.exports = __webpack_public_path__ + "img/lugares.57473369.png";